import { Box, keyframes } from "@mui/material";

// Smooth waveform animation
const wave = keyframes`
  0%, 100% { transform: scaleY(0.2); }
  50% { transform: scaleY(1); }
`;

export default function WaveformIcon({
  width = 400,
  height = 150,
  color = "#000",
  lines = 20,
}) {
  const lineGap = 4;
  const lineWidth = (width - lineGap * (lines - 1)) / lines;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        width,
        height,
        gap: `${lineGap}px`,
        mx: "auto",
      }}
    >
      {Array.from({ length: lines }).map((_, i) => (
        <Box
          key={i}
          sx={{
            width: `${lineWidth}px`,
            height: "100%",
            bgcolor: color,
            borderRadius: "2px",
            transformOrigin: "bottom",
            animation: `${wave} 5s ${i * 0.15}s infinite ease-in-out`,
            boxShadow: `0 0 8px rgba(0,0,0,0.3)`,
          }}
        />
      ))}
    </Box>
  );
}
